import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ShimanoPromotion } from 'src/app/model/product.model';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';

@Component({
  selector: 'app-potential-promotions',
  templateUrl: './potential-promotions.component.html',
  styleUrls: ['./potential-promotions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PotentialPromotionsComponent implements OnInit {
  @Input() potentialPromotions: Array<any> = [];
  @Input() appliedOrderPromotions: Array<any> = [];
  @Input() showSrp: boolean;
  @Input() savedCart: boolean;
  @Input() promotionLocation: string;
  constructor(private gtmService: GoogleTagManagerService) {}

  ngOnInit() {
    if (this.potentialPromotions.length) {
      this.gtmOrderPromotions(this.potentialPromotions);
    }
  }

  gtmOrderPromotions(promotions: ShimanoPromotion[]) {
    if (promotions.length) {
      promotions.forEach((promo, index) => {
        if (promo) {
          this.gtmService.pushTag({
            ecommerce: null,
            search_term: '',
            results_page: '',
            affiliation: '',
            content_type: '',
            content_id: '',
            content_name: '',
          });
          this.gtmService.pushTag({
            event: GoogleTagManagerEvent.PROMO_VIEW,
            ecommerce: {
              promotion_id: promo.code ? promo.code : promo.promotion.code,
              promotion_name: promo.description,
              creative_slot: this.promotionLocation,
              items: '',
            },
          });
        }
      });
    }
  }
}
